(() => {
  if (window.__otfNavigationAccessibilityReady) return;
  window.__otfNavigationAccessibilityReady = true;
  const popupSelector = '#menu-drawer[data-popup-type="mobile-navigation"]';
  const triggerSelector = '[data-modal-type="mobile-navigation"]';
  const overlaySelector = '.theme-popup-overlay, .theme-menu-popup-overlay';
  let state;
  let searchHandoff;

  const triggers = () => Array.from(document.querySelectorAll(triggerSelector));
  const otherPopupVisible = () => Boolean(document.querySelector('.rt-theme-popup:not(.hide-popup):not([data-popup-type="mobile-navigation"]), .overlay-navigation-panel__popup:not(.hide-popup)'));
  const ownsMenu = current => current && current.popup.isConnected && !current.popup.classList.contains('hide-popup') && document.body.getAttribute('active-popup') === 'mobile-navigation' && !otherPopupVisible();
  const focusable = popup => Array.from(popup.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]')).filter(element => element.tabIndex >= 0 && !element.closest('[inert]') && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');

  function restoreBackground(current) {
    current.background.forEach((value, element) => {
      if (value === null) element.removeAttribute('inert');
      else element.setAttribute('inert', value);
    });
    current.background.clear();
  }

  function clearSearchHandoff() {
    searchHandoff?.observer.disconnect();
    searchHandoff = null;
  }

  function handoffToSearch(current, trigger) {
    const popup = document.querySelector('.rt-theme-popup[data-popup-type="search"]');
    if (!popup) return;
    clearSearchHandoff();
    const handoff = { popup, trigger, opener: current.opener, wasOpen: false, observer: null };
    searchHandoff = handoff;
    // Release menu-owned inert before the native search observer opens its popup.
    restoreBackground(current);
    const update = () => {
      if (searchHandoff !== handoff) return;
      if (handoff.wasOpen && document.body.hasAttribute('active-popup') && document.body.getAttribute('active-popup') !== 'search') {
        clearSearchHandoff();
        return;
      }
      if (popup.isConnected && !popup.classList.contains('hide-popup')) {
        handoff.wasOpen = true;
        return;
      }
      if (!handoff.wasOpen) return;
      if (popup.isConnected && document.body.getAttribute('active-popup') === 'search') return;
      clearSearchHandoff();
      if (document.body.hasAttribute('active-popup') || otherPopupVisible()) return;
      const active = document.activeElement;
      if (active !== document.body && active !== trigger && !popup.contains(active)) return;
      const returnable = element => element?.isConnected && !element.disabled && element.tabIndex >= 0 && !element.closest('[inert]') && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden';
      const opener = returnable(handoff.opener) ? handoff.opener : triggers().find(returnable);
      opener?.focus({ preventScroll: true });
    };
    handoff.observer = new MutationObserver(update);
    handoff.observer.observe(popup, { attributes: true, attributeFilter: ['class'] });
    handoff.observer.observe(document.body, { attributes: true, attributeFilter: ['active-popup'], childList: true, subtree: true });
    requestAnimationFrame(() => {
      update();
      if (searchHandoff === handoff && !handoff.wasOpen) {
        clearSearchHandoff();
        if (state === current && ownsMenu(current)) isolateBackground(current);
      }
    });
  }

  function isolateBackground(current) {
    const allowed = [current.popup, ...document.querySelectorAll(overlaySelector)];
    const visit = element => {
      if (allowed.includes(element)) return;
      if (allowed.some(allowedElement => element.contains(allowedElement))) {
        Array.from(element.children).forEach(visit);
        return;
      }
      if (!current.background.has(element)) current.background.set(element, element.getAttribute('inert'));
      element.setAttribute('inert', '');
    };
    Array.from(document.body.children).forEach(visit);
  }

  function dispose(current) {
    const wasOpen = current.wasOpen || !current.popup.classList.contains('hide-popup');
    const active = document.activeElement;
    const focusWasInside = current.popup.contains(active);
    current.observers.forEach(observer => observer.disconnect());
    clearTimeout(current.timer);
    current.popup.removeEventListener('transitionend', current.onTransition);
    restoreBackground(current);
    if (!wasOpen) return;
    current.popup.classList.add('hide-popup');
    current.popup.inert = true;
    current.popup.setAttribute('aria-hidden', 'true');
    triggers().forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
    if (document.body.getAttribute('active-popup') === 'mobile-navigation') document.body.removeAttribute('active-popup');
    if (!otherPopupVisible()) {
      document.querySelectorAll(overlaySelector).forEach(overlay => overlay.classList.add('hidden-overlay'));
      document.querySelectorAll('.section-header.header__overlay').forEach(header => header.classList.remove('header__overlay'));
    }
    const opener = current.opener;
    if (!document.body.hasAttribute('active-popup') && !otherPopupVisible() && opener?.isConnected && !current.popup.contains(opener) && (focusWasInside || active === document.body || active === current.openingFocus)) opener.focus({ preventScroll: true });
  }

  function initialize() {
    const popup = document.querySelector(popupSelector);
    if (state?.popup === popup) return;
    if (state) dispose(state);
    state = null;
    if (!popup) return;
    const current = { popup, opener: null, wasOpen: false, observers: [], timer: null, openingFocus: null, background: new Map() };
    state = current;
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('tabindex', '-1');
    if (!popup.hasAttribute('aria-label') && !popup.hasAttribute('aria-labelledby')) {
      const trigger = triggers().find(element => element.getAttribute('aria-label') || element.textContent.trim());
      const label = trigger?.getAttribute('aria-label') || trigger?.textContent.trim();
      if (label) popup.setAttribute('aria-label', label);
    }
    popup.querySelectorAll('.dropdown-menu--toggle').forEach(toggle => {
      const submenu = toggle.nextElementSibling;
      if (!submenu?.classList.contains('menu-drawer__submenu')) return;
      const update = () => {
        const expanded = toggle.classList.contains('menu-expanded');
        submenu.inert = !expanded;
        submenu.setAttribute('aria-hidden', String(!expanded));
        toggle.setAttribute('aria-expanded', String(expanded));
      };
      if (submenu.id) toggle.setAttribute('aria-controls', submenu.id);
      const observer = new MutationObserver(update);
      observer.observe(toggle, { attributes: true, attributeFilter: ['class'] });
      current.observers.push(observer);
      update();
    });

    current.focusMenu = () => {
      if (state !== current || !ownsMenu(current)) return;
      const active = document.activeElement;
      if (popup.contains(active) || (active !== current.openingFocus && active !== current.opener && active !== document.body)) return;
      popup.focus({ preventScroll: true });
    };
    current.onTransition = event => {
      if (event.target === popup) current.focusMenu();
    };
    popup.addEventListener('transitionend', current.onTransition);
    current.update = () => {
      if (state !== current) return;
      if (!popup.isConnected) {
        initialize();
        return;
      }
      const isOpen = !popup.classList.contains('hide-popup');
      const focusWasInside = popup.contains(document.activeElement);
      popup.inert = !isOpen;
      popup.setAttribute('aria-hidden', String(!isOpen));
      triggers().forEach(trigger => {
        trigger.setAttribute('aria-controls', popup.id);
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-expanded', String(isOpen));
      });
      if (isOpen === current.wasOpen) {
        if (ownsMenu(current)) isolateBackground(current);
        else restoreBackground(current);
        return;
      }
      current.wasOpen = isOpen;
      clearTimeout(current.timer);
      if (isOpen) {
        current.openingFocus = document.activeElement;
        if (!current.opener?.isConnected || popup.contains(current.opener)) {
          const active = document.activeElement;
          current.opener = active !== document.body && !popup.contains(active) ? active : null;
        }
        if (ownsMenu(current)) isolateBackground(current);
        current.focusMenu();
        requestAnimationFrame(() => requestAnimationFrame(current.focusMenu));
        current.timer = setTimeout(current.focusMenu, 550);
      } else {
        restoreBackground(current);
        const opener = current.opener;
        const active = document.activeElement;
        current.opener = null;
        if (!document.body.hasAttribute('active-popup') && !otherPopupVisible() && opener?.isConnected && !popup.contains(opener) && (focusWasInside || active === document.body || active === current.openingFocus)) opener.focus({ preventScroll: true });
        current.openingFocus = null;
      }
    };
    const popupObserver = new MutationObserver(current.update);
    popupObserver.observe(popup, { attributes: true, attributeFilter: ['class'] });
    const bodyObserver = new MutationObserver(current.update);
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['active-popup'], childList: true, subtree: true });
    current.observers.push(popupObserver, bodyObserver);
    current.update();
  }

  document.addEventListener('click', event => {
    // Release the drawer even if the optional signup enhancement fails to load.
    const signup = event.target instanceof Element && event.target.closest('[data-otf-email-signup]');
    if (signup && ownsMenu(state) && state.popup.contains(signup)) {
      state.popup.querySelector('.theme-popup-close')?.click();
    }
    const drawerSearch = event.target instanceof Element && event.target.closest('[data-otf-drawer-search][data-modal-type="search"]');
    if (drawerSearch && ownsMenu(state) && state.popup.contains(drawerSearch)) {
      handoffToSearch(state, drawerSearch);
      return;
    }
    const trigger = event.target instanceof Element && event.target.closest(triggerSelector);
    if (!trigger) return;
    initialize();
    if (state && state.popup.classList.contains('hide-popup')) state.opener = trigger;
  }, true);
  document.addEventListener('keydown', event => {
    if (!ownsMenu(state)) return;
    const popup = state.popup;
    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopImmediatePropagation();
      popup.querySelector('.theme-popup-close')?.click();
      return;
    }
    if (event.key !== 'Tab') return;
    event.stopImmediatePropagation();
    const items = focusable(popup);
    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement;
    if (!first) {
      event.preventDefault();
      popup.focus({ preventScroll: true });
    } else if (event.shiftKey && (active === first || active === popup || !popup.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || active === popup || !popup.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  }, true);
  // Native focus can leave a partially visible link clipped in a horizontal row.
  // Reveal only the focused destination; do not move page scroll or change focus.
  document.addEventListener('focusin', event => {
    const destination = event.target instanceof Element && event.target.closest('a[href], button');
    if (!destination) return;
    const rowSelector = ':is(.otf-department-rail, .otf-category-shelf__tabs, .otf-category-shelf__fallback, .otf-refinement__row > .otf-refinement__choices, .otf-collection-choices, .otf-catalog-shortcuts__list, .otf-drawer-photo-strip__track, .otf-story-track, .otf-story-media-track, .otf-story-products, .otf-home-brand-products .product-grid, .otf-pro-standard__products, .otf-news__nav, .otf-news-archive__nav, .otf-news__product-scroll, .otf-news__products, .otf-stacy-catalog__track, .template-index #MainContent .otf-brand-navigation):not(.slider)';
    let row = destination.parentElement?.closest(rowSelector);
    while (row && (row.scrollWidth <= row.clientWidth + 1 || !/^(auto|scroll)$/.test(getComputedStyle(row).overflowX))) {
      row = row.parentElement?.closest(rowSelector);
    }
    if (!row) return;
    const bounds = row.getBoundingClientRect();
    const item = destination.getBoundingClientRect();
    const left = bounds.left + row.clientLeft;
    const right = left + row.clientWidth;
    const clearance = Math.min(3, Math.max(0, (row.clientWidth - item.width) / 2));
    let delta = 0;
    if (item.width > row.clientWidth || item.left < left + clearance) delta = item.left - left - clearance;
    else if (item.right > right - clearance) delta = item.right - right + clearance;
    const range = row.scrollWidth - row.clientWidth;
    const rtl = getComputedStyle(row).direction === 'rtl';
    const minimum = rtl ? -range : 0;
    const maximum = rtl ? 0 : range;
    delta = Math.max(minimum, Math.min(maximum, row.scrollLeft + delta)) - row.scrollLeft;
    if (Math.abs(delta) > 1) row.scrollBy({ left: delta, behavior: 'auto' });
  });

  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    if (state && event.target instanceof Element && event.target.contains(state.popup)) {
      dispose(state);
      state = null;
    }
    requestAnimationFrame(initialize);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
